<app-store-status-banner></app-store-status-banner>
@if (isMobile()) {
  @if (!isGifting()) {
    <div class="mobile-nav-container">
      <div class="mobile-top-bar" [style.background-color]="headerBackgroundColor()">
        <div class="flex flex-row align-items-center">
          <button
            type="button"
            pButton
            icon="pi pi-bars"
            aria-label="Open menu"
            class="mr-2"
            (click)="mobileMenuVisible = true"
          ></button>

          <button
            type="button"
            pButton
            icon="pi pi-search"
            aria-label="Search"
            (click)="mobileSearchVisible = true"
          ></button>
        </div>

        <!-- Logo -->
        <div class="mobile-logo">
          <img [src]="logo.src" alt="Logo" class="logo-img mobile-logo" />
        </div>

        <!-- Cart -->
        <div class="flex flex-row align-items-center">
          <!-- When prices are disabled, do not show gift card balance -->
          @if (!basePointsEnabled && giftCardBalance() > 0 && !disabledPrices) {
            <div class="flex mr-3">
              <img ngSrc="assets/img/icons/gift-card-tag.svg" alt="cart" width="24" height="24" />
              <span class="gift-card-balance desktop-balance">
                {{ giftCardBalance() | price | usdPipe }}
              </span>
            </div>
          }
          @if (basePointsBalance(); as baseBalance) {
            <span class="base-points-balance" aria-label="Available Base points">
              {{ baseBalance.available_points | basePoints: basePointsCurrency() }}
            </span>
          }

          <a
            routerLink="/cart"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="mobile-cart-link"
          >
            <img ngSrc="assets/img/icons/cart.svg" alt="cart" height="24" width="24" />
            @if (cartItemsLength() > 0) {
              <div class="items-icon">{{ cartItemsLength() }}</div>
            }
          </a>
        </div>
      </div>

      <!-- Mobile search sidebar -->
      <p-drawer [(visible)]="mobileSearchVisible" [modal]="true" position="top">
        <ng-template #header>
          <span class="search-products-title">Search Products</span>
        </ng-template>
        <div class="search-products-sidebar">
          <app-search />
        </div>
      </p-drawer>

      <!-- Mobile menu sidebar -->
      <p-drawer
        [(visible)]="mobileMenuVisible"
        [modal]="true"
        position="left"
        [closable]="false"
        [styleClass]="menuTextColor() ? 'custom-menu-text' : ''"
        [style]="{
          backgroundColor: menuBackgroundColor(),
          '--menu-text-color': menuTextColor()
        }"
      >
        <ng-template #header>
          <!-- Custom close button -->
          <button type="button" class="custom-sidebar-close" (click)="mobileMenuVisible = false">
            <i class="pi pi-times"></i>
          </button>

          <!-- Search and user section -->
          <div class="mobile-sidebar-header-content">
            <div class="mobile-sidebar-search">
              <app-search />
            </div>
            <div class="mobile-sidebar-user">
              @if (userName()) {
                <a
                  routerLink="/my-account"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                  class="mobile-user-link"
                  (click)="mobileMenuVisible = false"
                >
                  <img ngSrc="assets/img/icons/user.svg" alt="user" height="24" width="24" />
                </a>
              } @else {
                <app-button
                  label="Login"
                  linkTo="/login"
                  (click)="mobileMenuVisible = false"
                ></app-button>
              }
            </div>
          </div>
        </ng-template>

        <!-- Recursive menu template -->
        <ng-template #recursiveList let-items>
          <div class="p-menu mobile-menu-panel" [style.background-color]="menuBackgroundColor()">
            <div class="custom-mobile-menu">
              <ul class="p-menu-list p-reset">
                @for (item of items; track item.label) {
                  <li class="p-element p-menu-item">
                    <div class="p-menu-item-content">
                      @if (item.href) {
                        <a
                          class="p-ripple p-element p-menu-item-link p-menu-item-link-active"
                          [href]="item.href"
                          target="_blank"
                        >
                          {{ item.label }}
                        </a>
                      } @else {
                        <a
                          class="p-ripple p-element p-menu-item-link p-menu-item-link-active"
                          [routerLink]="item.routerLink"
                          (click)="$event.preventDefault(); item.command()"
                        >
                          {{ item.label }}
                        </a>
                      }
                    </div>

                    @if (item.items) {
                      <div class="submenu" style="margin-left: 10px">
                        <ng-container
                          *ngTemplateOutlet="recursiveList; context: { $implicit: item.items }"
                        ></ng-container>
                      </div>
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
        </ng-template>

        <ng-container
          *ngTemplateOutlet="recursiveList; context: { $implicit: menuItemsForPrimeNg() }"
        ></ng-container>

        <!-- Logout section at bottom -->
        @if (userName()) {
          <div class="mobile-sidebar-bottom">
            <div class="mobile-sidebar-divider"></div>
            <button type="button" class="mobile-logout-button" (click)="logout()">
              <span>Logout</span>
            </button>
          </div>
        }
      </p-drawer>
    </div>
  } @else {
    <div class="mobile-gifting-container">
      <div class="mobile-gifting-logo" [style.background-color]="headerBackgroundColor()">
        <img [src]="logo.src" alt="Logo" class="logo-img" />
      </div>
    </div>
  }
} @else {
  <!-- DESKTOP LAYOUT -->
  <div class="navbar-desktop" [style.background-color]="headerBackgroundColor()">
    <div class="inner-container">
      <div class="pre-nav" [ngClass]="{ 'center-logo': logoPosition() === 'center' }">
        <!-- Logo -->
        <div class="logo flex">
          <img class="logo-img" [src]="logo.src" alt="logo" />
        </div>

        @if (logoPosition() === 'center') {
          <div class="spacer"></div>
        }

        <!-- Icons block -->
        @if (!isGifting()) {
          <div class="icons" [ngClass]="{ 'right-icons': logoPosition() === 'center' }">
            <span><app-search /></span>
            <!-- When prices are disabled, do not show gift card balance -->
            @if (!basePointsEnabled && giftCardBalance() > 0 && !disabledPrices) {
              <div class="flex">
                <img ngSrc="assets/img/icons/gift-card-tag.svg" alt="cart" width="24" height="24" />
                <span class="gift-card-balance desktop-balance">
                  {{ giftCardBalance() | price | usdPipe }}
                </span>
              </div>
            }
            @if (basePointsBalance(); as baseBalance) {
              <span class="base-points-balance" aria-label="Available Base points">
                {{ baseBalance.available_points | basePoints: basePointsCurrency() }}
              </span>
            }

            <!-- Cart -->
            <a
              class="icon-shadow"
              routerLink="/cart"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
            >
              <img ngSrc="assets/img/icons/cart.svg" alt="cart" width="24" height="24" />
              @if (cartItemsLength() > 0) {
                <div class="items-icon">{{ cartItemsLength() }}</div>
              }
            </a>

            <!-- User / Login -->
            @if (userName()) {
              <div
                (mouseenter)="onMouseEnter($event)"
                (mouseleave)="onMouseLeave()"
                class="user-menu-container"
              >
                <p-menu #userMenu [popup]="true" [model]="userMenuItems" [dt]="menuDt"></p-menu>
                <a class="p-menuitem-link flex align-items-center gap-2 cart">
                  <img class="icon-img icon-shadow" src="assets/img/icons/user.svg" alt="user" />
                  <span>{{ userName() }}</span>
                </a>
              </div>
            } @else {
              <app-button label="{{ 'LOGIN.login' | translate }}" linkTo="/login" />
            }
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Main nav bar -->
  @if (!isGifting()) {
    <div [style.background-color]="menuBackgroundColor()">
      <div class="inner-container">
        <p-menubar
          [style]="{
            flexDirection: 'column',
            border: 'none',
            background: 'transparent',
            '--menu-background-color': menuBackgroundColor(),
            '--menu-text-color': menuTextColor()
          }"
          [class.custom-menu-background]="menuBackgroundColor()"
          [class.custom-menu-text]="menuTextColor()"
          [model]="menuItemsBar()"
          [dt]="menubarDt"
        >
          <ng-template #item let-item let-root="root">
            @if (item.href && item.href.includes('http')) {
              <a
                class="flex align-items-center p-menubar-item-link"
                [href]="item.href"
                target="_blank"
              >
                {{ item.label }}
              </a>
            } @else {
              <a
                pRipple
                [routerLink]="item.routerLink"
                class="flex align-items-center p-menubar-item-link"
              >
                <span>{{ item.label }}</span>
              </a>
            }
          </ng-template>
        </p-menubar>
      </div>
    </div>
  }
}
